if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
  super();

  this.elements = {
    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
    viewer: this.querySelector('[id^="GalleryViewer"]'),
    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
  };

  this.mql = window.matchMedia('(min-width: 750px)');

  // サムネイルの有無に関係なく、画像変更を監視する
  if (this.elements.viewer) {
    this.elements.viewer.addEventListener(
      'slideChanged',
      debounce(this.onSlideChanged.bind(this), 500)
    );
  }

  // サムネイルがない場合は、ここで終了
  if (!this.elements.thumbnails) return;

  this.elements.thumbnails
    .querySelectorAll('[data-target]')
    .forEach((mediaToSwitch) => {
      const button = mediaToSwitch.querySelector('button');

      if (!button) return;

      button.addEventListener(
        'click',
        this.setActiveMedia.bind(
          this,
          mediaToSwitch.dataset.target,
          false
        )
      );
    });

  if (
    this.dataset.desktopLayout?.includes('thumbnail') &&
    this.mql.matches
  ) {
    this.removeListSemantic();
  }
}







      onSlideChanged(event) {
  const currentMedia = event.detail.currentElement;

  if (!currentMedia) return;

  if (this.elements.thumbnails) {
    const thumbnail = this.elements.thumbnails.querySelector(
      `[data-target="${currentMedia.dataset.mediaId}"]`
    );

    this.setActiveThumbnail(thumbnail);
  }

  this.selectImageColor(currentMedia);
}

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
        this.selectImageColor(activeMedia);

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
      selectImageColor(mediaElement) {
        if (!mediaElement) return;

        const imageAlt = mediaElement.dataset.imageAlt?.trim();
        if (!imageAlt) return;

        const productSection =
          this.closest('.shopify-section') || document;

        const colorRadios = Array.from(
          productSection.querySelectorAll(
            '.swatch-input__input[type="radio"]'
          )
        );

        // 「ブラウン」より「ダークブラウン」を先に判定する
        const matchedRadio = colorRadios
          .sort((a, b) => b.value.length - a.value.length)
          .find((radio) => {
            const colorName = radio.value.trim();
            return colorName && imageAlt.includes(colorName);
          });

        if (!matchedRadio || matchedRadio.checked) return;

        matchedRadio.click();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const button = thumbnail.querySelector('button');
        if (!button) return;

        button.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
